import { BottomMenuModal } from 'components/modals/ModalContainer/components/BottomMenuModal';
import { ComponentModal } from 'components/modals/ComponentModal';
import { WideComponentModal } from '../WideComponentModal';
import { CameraModal, PdfModal } from './components';

export const Modals = {
  componentModal: ComponentModal,
  inviteUsersModal: ComponentModal,
  cameraModal: CameraModal,
  pdfModal: PdfModal,
  bottomMenuModal: BottomMenuModal,
  wideComponentModal: WideComponentModal,
} as const;
